export let SubscriptionPlan;
(function (SubscriptionPlan) {
  SubscriptionPlan["Basic"] = "Basic";
  SubscriptionPlan["Standard"] = "Standard";
})(SubscriptionPlan || (SubscriptionPlan = {}));
export const SubscriptionPlanIds = {
  [SubscriptionPlan.Basic]: 'a0a0a0a0-0000-0000-0000-000000000001',
  [SubscriptionPlan.Standard]: 'a0a0a0a0-0000-0000-0000-000000000002'
};

// Reverse mapping for when you get an ID and need the plan name
export const IdToSubscriptionPlan = {
  'a0a0a0a0-0000-0000-0000-000000000001': SubscriptionPlan.Basic,
  'a0a0a0a0-0000-0000-0000-000000000002': SubscriptionPlan.Standard
};

// Helper functions
export const getSubscriptionPlanId = plan => {
  return SubscriptionPlanIds[plan];
};
export const getSubscriptionPlanName = id => {
  return IdToSubscriptionPlan[id];
};

// Type for the actual ID values